import $ from 'jquery';
import 'slick-carousel';

var $caseSlider = $('.case-slider__items');

$caseSlider.each(function(num, elem) {
    var $elem = $(elem);
    var index = $elem.parents('.case-slider').attr('data-id');

    $elem.slick({
        autoplay: false,
        infinite: false,
        arrows: true,
        dots: true,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="slick-prev angle-left"></i>',
        nextArrow: '<i class="slick-next angle-right"></i>',
        appendArrows: $('<div>').addClass('absolute-container arrow-container').insertAfter('#case-slider-' + index + ' .case-slider__items'),
        appendDots: $('<div>').addClass('dots-container').insertAfter('#case-slider-' + index + ' .case-slider__items'),
        mobileFirst: true,
        responsive: [{
            breakpoint: 991,
            settings: {
                draggable: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
            }
        },{
            breakpoint: 1279,
            settings: {
                draggable: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false,
            }
        },{
            breakpoint: 1919,
            settings: {
                draggable: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: false,
            }
        }]
    });
});
